import React, { Component } from "react";

const InnerCard = props => {
    return (
        <div className="card" onClick={() => props.onClick(props)}>
            <div className={`image image-${props.StoryImage}`} title={props.Credit && `צילום: ${props.Credit}`}>
                {props.Credit && <div className="credit">צילום: {props.Credit}</div>}
                <div className="views">
                    <div className="icon"></div>
                    <div className="counter">{props.Views}</div>
                </div>
                <div className="date">{props.PublishDate}</div>
            </div>
            <div className="info">
                <div className="country">
                    <div className={`flag flag-${props.FlagPhoto}`}></div>
                    <div className="name">{props.Area}</div>
                </div>
                <div className="title">{props.Title}</div>
                <div className="desc">{props.Description}</div>
                <div className="date">{props.PublishDate}</div>
                <div className="button">
                    לקריאת הכתבה
            </div>
            </div>
        </div>
    )
}

export {
    InnerCard
}


// WEBPACK FOOTER //
// ./src/Components/Helpers/CardHelper.jsx